// AccessDeniedPage.js
import React from 'react';
import { Link } from 'react-router-dom';

// Define the styles object above the component
const styles = {
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f7f7f7',
    textAlign: 'center',
    padding: '20px',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#e74c3c',
  },
  message: {
    fontSize: '1.2rem',
    marginBottom: '20px',
    color: '#2c3e50',
  },
  link: {
    color: '#3498db',
    textDecoration: 'none',
    fontSize: '1rem',
  },
};

const AccessDeniedPage = () => (
  <div style={styles.pageContainer}>
    <h1 style={styles.title}>Access Denied</h1>
    <p style={styles.message}>You do not have permission to view this page.</p>
    <p>
      <Link to="/app_dashboard" style={styles.link}>Go back to the homepage</Link>
    </p>
  </div>
  );

export default AccessDeniedPage;
